import ContinuePage from "@components/ContinuePage"

export default function HomeDoingGreatPage() {
  return <ContinuePage emoji="🌟" translationKey="homeDoingGreat" />
}
